<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo.jpg" alt="logo图" >
    </div>
    <p class="title">孝感市城市理工技工学院有限公司</p>
    <p class="address_tel_fax">
      <span>地址：湖北省孝感市孝南区三汊镇孝汉大道18号 Tel：0712-2036116 0712-2036118</span>
    </p>
    <p class="email_wx">
      <span>邮箱：1205574781@qq.com 公司微信号：18582856154</span>

    </p>
    <a class="copy" href="https://beian.miit.gov.cn/#/Integrated/index" style="margin:50px 0 10px 0;display:block">备案号：鄂ICP备2023011170号-1</a>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 95px;
  margin: 50px auto 20px;
}
img{
  width: 95px;
  height: 95px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue